// A MediaFilters collection name (Libs/MediaFilters.php); 'guide_document'
// resolves to onlyDocuments, so both browse and upload filter to documents.
const DOCUMENT_ACCEPTS = 'guide_document';

/** A document picked from the media library, as the v2 editors store it. */
export type EditorDocument = {
   documentid: number;
   /** The document's title, falling back to its filename. */
   title: string;
   filename: string;
   /**
    * DisplayDocument::getDocumentType() (Objects/DisplayDocument.php).
    * Empty when the picker didn't carry one.
    */
   documentType: string;
};

/**
 * Opens the media library filtered to documents and resolves with the
 * chosen one, or null when the user cancels. The flat media item is adapted
 * to the {documentid, title, filename} shape the editors store.
 */
export async function browseForDocument(): Promise<EditorDocument | null> {
   const { openMediaManager } = await import('Shared/MediaManager');
   const item = await openMediaManager({ accepts: DOCUMENT_ACCEPTS });

   if (!item || item.documentid === undefined) {
      return null;
   }

   return {
      documentid: item.documentid,
      title: item.title || item.filename || '',
      filename: item.filename ?? '',
      documentType: item.document_type ?? '',
   };
}
